<template>
  <div>
    <GroupHeader :width="845" :left="556" :top="632" :title="$t('Monitoring1025.currentSpeedProfile')" />
    <div class="speed-container" :style="{ width: width + 'px', height: height + 'px', left: left + 'px', top: top + 'px' }">
      <div id="speedChart" class="speed-chart"></div>
      <!-- <div class="left-tip">m</div> -->
      <div class="right-tip">m/s</div>
    </div>
  </div>
</template>
<script>
import GroupHeader from './GroupHeader.vue'
import * as echarts from 'echarts'

export default {
  props: {
    width: {
      type: Number,
      default: 845
    },
    height: {
      type: Number,
      default: 344
    },
    left: {
      type: Number,
      default: 561
    },
    top: {
      type: Number,
      default: 678
    },
    adcpdData: {
      type: Array
    }
  },
  components: { GroupHeader },
  data() {
    return {
      speedChart: null,
      speedChartData: null,
      timeArrs: [],
      hotData: [], // 热力图数据
      maxSpeedValue: 0
    }
  },
  watch: {
    adcpdData(newVal) {
      if (newVal != null && Array.isArray(newVal)) {
        let timeArrs = [],
          dataArray = []
        this.maxSpeedValue = 0
        // 流速的所有数据
        let velocityKeys = Object.keys(newVal[0])
          .filter(item => item.indexOf('Current Velocity') != -1)
          .sort()
          .slice(0, 8)
        let levels = []
        for (let i = 0; i < velocityKeys.length; i++) {
          levels.push(i + 1)
        }
        this.levels = levels.reverse()
        // 倒序排列
        for (let i = newVal.length - 1; i >= 0; i--) {
          let item = newVal[i]
          // 时间
          let index1 = item['时间'].indexOf('/')
          let index2 = item['时间'].lastIndexOf(':')
          timeArrs.push(item['时间'].substring(index1 + 1, index2))
          // 数据
          let row = newVal.length - 1 - i
          let col = velocityKeys.length - 1

          for (let j = 0; j < velocityKeys.length; j++) {
            let velocity = Number(item[velocityKeys[j]])
            // velocity 处以1000，然后最大是3
            velocity = Math.min(velocity / 1000, 3)
            velocity = Number(velocity.toFixed(3))
            this.maxSpeedValue = Math.max(this.maxSpeedValue, velocity)
            if (velocity === '0.00') velocity = '-'
            dataArray.push([row, col, velocity])
            col--
          }
        }
        this.timeArrs = timeArrs
        this.hotData = dataArray
        this.setLineChartOptions()
      }
    }
  },
  methods: {
    initChart() {
      this.speedChart = echarts.init(document.getElementById('speedChart'))
      this.setLineChartOptions(this.speedChartData)
    },
    setLineChartOptions() {
      let option = {
        tooltip: {
          position: 'top'
        },
        grid: {
          bottom: '10%',
          top: '10%',
          right: '7%',
          left: '5%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.timeArrs,
          axisLabel: {
            textStyle: {
              color: '#7CC5F7',
              fontSize: 12,
              width: 2
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          name: 'Cell(4m/cell)',
          type: 'category',
          data: this.levels,
          axisLabel: {
            textStyle: {
              color: '#7CC5F7',
              fontSize: 12,
              width: 2
            }
          },
          splitLine: {
            show: false
          }
        },
        visualMap: {
          min: 0,
          max: this.maxSpeedValue,
          calculable: true,
          right: '0%',
          bottom: '7%',
          itemWidth: 9,
          itemHeight: 280,
          align: 'left',
          textStyle: {
            color: 'rgba(124, 197, 247, 1)',
            fontSize: 12
          },
          inRange: {
            color: ['#030b69', '#0249c1', '#19bba9', '#a9bb1a', '#b53b0e', '#580a12']
          }
        },
        series: [
          {
            name: this.$t('Monitoring1025.currentSpeed'),
            type: 'heatmap',
            data: this.hotData,
            label: {
              show: false
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.speedChart.setOption(option)
    }
  },
  created() {},
  mounted() {
    this.initChart()
  },
  destroyed() {
    if (this.speedChart) {
      this.speedChart.dispose()
      this.speedChart = null
    }
  }
}
</script>

<style lang="scss" scoped>
.speed-container {
  position: absolute;
  background: rgba(23, 78, 128, 0.22);

  .speed-chart {
    height: 100%;
  }

  .left-tip {
    position: absolute;
    color: white;
    left: 20px;
    top: 4px;
  }
  .right-tip {
    position: absolute;
    color: white;
    right: 8px;
    top: 4px;
  }
}
</style>
